import { createSelector } from "reselect";
import { ApplicationState } from "#store/types";

export const selectEnvServiceUrl = createSelector(
    [(state: ApplicationState) => state.environment],
    state => state.SERVICE_URL
);
